<template>
  <Row
    type="flex"
    class="code-row-bg"
    justify="center"
    style="margin-bottom:150px;"
  >
    <i-col span="24" class="qfacts">
      <Card
        dis-hover
        v-for="(fact, idx) in quickFacts"
        :key="idx"
        style="margin: 0 0 24px 0; border:1px dashed #ddd;"
      >
        <QuickFactForm
          v-model="quickFacts[idx]"
          :idx="idx"
          :ref="'qfact' + idx"
        >
          <i-form-item class="action-buttons">
            <i-button @click="cloneQuickFact(idx)" icon="social-buffer">
              Clone Quick Fact
            </i-button>
            <i-button @click="deleteQuickFact(idx)" icon="close" type="error">
              Delete Quick Fact
            </i-button>
          </i-form-item>
        </QuickFactForm>
      </Card>

      <i-button @click="addQuickFact" icon="plus"> Add Quick Fact </i-button
      >&nbsp;
      <i-button
        type="warning"
        @click="createQuickFacts"
        v-show="this.quickFacts.length > 0"
      >
        Save All Quick Facts
      </i-button>
      <!--
          <i-button type="warning" @click="debug" v-show="this.quickFacts.length > 0">Debug All Quick Facts</i-button>
        -->
    </i-col>
  </Row>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import QuickFactForm from "./quick_fact_form.vue";

export default {
  components: { QuickFactForm },
  props: ["documentid", "loading"],
  data() {
    return {
      quickFacts: [],
    };
  },
  computed: {
    lastQuickFact() {
      return this.quickFacts[this.quickFacts.length - 1] || {};
    },
  },
  methods: {
    debug() {
      let allValid = true;
      for (let i = 0; i < this.quickFacts.length; i++) {
        this.$refs["qfact" + i][0].$refs["form"].validate(
          valid => (allValid = allValid && valid)
        );
      }
      if (allValid) {
        console.log(this.quickFacts);
      }
    },
    addQuickFact() {
      console.log(this.lastQuickFact);
      let fact = {
        document_id: this.documentid,
        name: "",
        year: this.lastQuickFact.year,
        iso3: this.lastQuickFact.iso3,
        type: this.lastQuickFact.type,
        displacement_type: this.lastQuickFact.displacement_type,
        data: {
          reported_figure: 0,
          unit: "Person",
          figure: 0,
          stock_date: {
            date: null,
            accuracy: null,
          },
          start_date: {
            date: null,
            accuracy: null,
          },
          end_date: {
            date: null,
            accuracy: null,
          },
        },
        household_size: {
          figure: 0,
          type: "Manual",
        },
        created_by: this.user,
      };
      this.quickFacts.push(fact);
    },
    deleteQuickFact(id) {
      this.$Modal.confirm({
        title: "Delete Quick Fact",
        content:
          "This action will permanently delete this quick fact, are you sure?",
        onOk: () => {
          this.quickFacts = _.filter(this.quickFacts, (f, i) => {
            return i !== id;
          });
        },
        // onCancel: () => {},
      });
    },
    cloneQuickFact(id) {
      this.quickFacts.push(_.cloneDeep(this.quickFacts[id]));
    },
    createQuickFacts() {
      let allValid = true;
      for (let i = 0; i < this.quickFacts.length; i++) {
        this.$refs["qfact" + i][0].$refs["form"].validate(
          valid => (allValid = allValid && valid)
        );
      }
      if (!allValid) {
        this.$Notice.error({
          title: "Error",
          desc: "Check the quick fact forms for errors",
          duration: 8,
        });
      } else {
        this.$emit("loading", true);
        // remove and format dates
        // for (let i = 0; i < this.quickFacts.length; i++) {
        //   if (_.includes(this.quickFacts[i].type, "Flow")) {
        //     delete this.quickFacts[i].data.stock_date;
        //   } else {
        //     delete this.quickFacts[i].data.start_date;
        //     delete this.quickFacts[i].data.end_date;
        //   }
        //   console.log(this.quickFacts[i]);
        // }
        for (let qf of this.quickFacts) {
          if (_.includes(qf.type, "Flow")) {
            delete qf.data.stock_date;
          } else {
            delete qf.data.start_date;
            delete qf.data.end_date;
          }
          console.log(qf);
        }

        axios
          .post("/psql/facts", this.quickFacts)
          .then(() => {
            this.quickFacts = [];
            this.loadingSuccess("Facts have been created");
            this.$emit("loading", false);
            this.$router.push(`/documents/${this.documentid}`);
          })
          .catch(error => {
            console.error(error.response);
            this.loadingError("Failed to create fact");
            this.$emit("loading", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.qfacts {
  padding: 12px;
  border: 1px dashed #eee;
}
</style>
